// const userType = [
//     { id: 1, role: 'Admin' },
//     { id: 2, role: 'Staff' },
//     { id: 3, role: 'User' },
// ];

function get_user_role() {
  let user = getUser();
  return isEmpty(user?.user_type) ? "user" : user.user_type;
}

function get_polygon_color(user_type) {
  let type = isEmpty(user_type) ? "customer" : user_type;
  let color;
  if (type === "admin") {
    color = "#7351A6";
  } else if (type === "staff") {
    color = "#FC9F67";
  } else if (type === "customer") {
    color = "#94A869";
  }
  return color;
}
function custom_str_to_lower(response) {
  return response.toLowerCase();
}

function getIconCategory(value) {
  var IconCategory;
  var IconPrefix;
  let category = custom_str_to_lower(value);

  if (
    category === "iedMarker" ||
    category.includes("ied") ||
    category.includes("Ied") ||
    category.includes("vbied")
  ) {
    IconCategory = "bomb";
    IconPrefix = "fa";
  } else if (
    category === "gfMarker" ||
    category.includes("gunfire") ||
    category.includes("isolated")
  ) {
    IconCategory = "times-circle";
    IconPrefix = "fa";
  } else if (
    category === "vcMarker" ||
    category.includes(" clash") ||
    category.includes("voilent")
  ) {
    IconCategory = "fire";
    IconPrefix = "fa";
  } else if (
    category === "carjacking" ||
    category.includes("car") ||
    category.includes("jacking")
  ) {
    IconCategory = "car";
    IconPrefix = "fa";
  } else if (
    category === "airstrike" ||
    category.includes("air") ||
    category.includes("strike")
  ) {
    IconCategory = "fighter-jet";
    IconPrefix = "fa";
  } else if (
    category === "mortar/rocket" ||
    category.includes("rocket") ||
    category.includes("mortar")
  ) {
    IconCategory = "rocket";
    IconPrefix = "fa";
  } else if (
    category === "uav" ||
    category.includes("unmanned") ||
    category.includes("aerial") ||
    category.includes("vehicles")
  ) {
    IconCategory = "plane";
    IconPrefix = "fa";
  } else if (category === "oMarker" || category.includes("other")) {
    IconCategory = "crosshairs";
    IconPrefix = "fa";
  } else if (category === "kidnapping"){
    IconCategory = "child";
    IconPrefix = "fa";
  }
   else {
    IconCategory = "crosshairs";
    IconPrefix = "fa";
  }
  return {
    category: IconCategory,
    icon: IconPrefix,
  };
}

function getMarkerColor(impact) {
  var Mcolor;
  if (impact === "high") {
    Mcolor = "red";
  } else if (impact === "medium") {
    Mcolor = "orange";
  } else if (impact === "low") {
    Mcolor = "green";
  } else {
    Mcolor = "yellow";
  }
  return Mcolor;
}

function parse_filter_records(filterRecords) {
  let allIncidents = [];
  let incidentDetail,
    incident,
    targets,
    attackers,
    attacks,
    category,
    icon,
    color;
  filterRecords &&
    filterRecords.map((filterRecord, idx) => {
      incident = filterRecord?.incident_place;
      targets = filterRecord?.targets;
      attackers = filterRecord?.attackers;
      attacks = filterRecord?.attacks;
      category = isEmpty(filterRecord?.attacks) ? null : attacks[0];
      icon = isEmpty(category)
        ? getIconCategory("dummy")
        : getIconCategory(category);
      color = getMarkerColor(custom_str_to_lower(filterRecord?.impact));

      incidentDetail = {
        id: filterRecord?.id,
        icon: icon,
        color: color,
        position: [incident?.latitude, incident?.longitude],
        intensity: filterRecord?.impact,
        type: targets.join(),
        date: filterRecord?.date,
        area: incident?.area,
        district: incident?.district_name?.name,
        accuracy: filterRecord?.accuracy,
        attacker: attackers.join(),
        attack: attacks.join(),
        casualties: parseInt(filterRecord?.casualties),
        fatalities: parseInt(filterRecord?.fatalities),
        detail: filterRecord?.details,
        url: incident?.google_map_url,
        related_incident: filterRecord?.related_incident,
      };
      allIncidents.push(incidentDetail);
      return null;
    });
  return allIncidents;
}

function parse_country(cityRecord, user) {
  const countries = cityRecord.countries;
  const cities = cityRecord.cities;
  let userCountryObject;
  let userCitiesObject = [];
  let countryId = null;
  let userCityObject = {
    city: null,
    cities: null,
    country: null,
  };
  countries &&
    countries.map((country, id) => {
      if (user?.city?.country?.name === country.label) {
        countryId = country.id;
      }
      return null;
    });

  cities &&
    cities.map((city, idx) => {
      let cityVal = city.values;
      if (city.id === countryId) {
        userCitiesObject = cityVal;
      }
      cityVal &&
        cityVal.map((cityObj, id) => {
          if (user?.city?.name === cityObj.label) {
            countries &&
              countries.map((country, id) => {
                if (city.id === country.id) {
                  userCountryObject = country;
                  userCityObject.country = userCountryObject;
                }
                return null;
              });
            userCityObject.city = cityObj;
          }
          return null;
        });
      return null;
    });
  userCityObject.cities = userCitiesObject;
  return userCityObject;
}

function capitalizeFirstLetter(string) {
  var val = "";
  if (!isEmpty(string)) {
    val = string.charAt(0).toUpperCase() + string.slice(1);
  }
  return val;
}

function getUser() {
  let user = localStorage.getItem("user");
  if (isEmpty(user)) return null;
  return JSON.parse(user);
}

function isEmpty(x) {
  return (
    typeof x === "undefined" ||
    x === null ||
    x === false || //same as: !x
    x.length === 0 ||
    x === ""
    // ||
    // (x.replace(/\s/g,"") === "")
    // ||
    // (!/[^\s]/.test(x))
    // ||
    // (/^\s*$/.test(x))
  );
}

function ucfirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function isLeapYear(year) {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

function getDaysInMonth(year, month) {
  return [
    31,
    isLeapYear(year) ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ][month];
}

function getDate(date, value) {
  var d = new Date(date),
    n = date.getDate();
  d.setDate(1);
  d.setMonth(d.getMonth() + value);
  d.setDate(Math.min(n, getDaysInMonth(d.getFullYear(), d.getMonth())));
  return d;
}

export const helper = {
  isEmpty,
  get_user_role,
  get_polygon_color,
  getUser,
  parse_country,
  // userType,
  custom_str_to_lower,
  parse_filter_records,
  capitalizeFirstLetter,
  ucfirst,
  getDate,
};
